import React from 'react';

interface ProgressBarProps {
  currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
  const steps = [
    { number: 1, title: 'Details', isActive: currentStep >= 1, isCompleted: currentStep > 1 },
    { number: 2, title: 'Payment', isActive: currentStep >= 2, isCompleted: currentStep > 2 },
    { number: 3, title: 'Confirmation', isActive: currentStep >= 3, isCompleted: currentStep > 3 }
  ];

  return (
    <div className="w-full bg-white py-6 shadow-sm">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="flex flex-col items-center">
                <div 
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${
                    step.isCompleted
                      ? 'bg-green-500 text-white'
                      : step.isActive
                      ? 'bg-[#203D32] text-white'
                      : 'bg-gray-200 text-gray-500'
                  }`}
                >
                  {step.isCompleted ? (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    step.number
                  )}
                </div>
                <span 
                  className={`mt-2 text-sm font-medium ${
                    step.isActive ? 'text-[#203D32]' : 'text-gray-500'
                  }`}
                >
                  {step.title}
                </span>
              </div>
              
              {index < steps.length - 1 && (
                <div 
                  className={`flex-1 h-1 mx-4 rounded ${
                    step.isCompleted ? 'bg-green-500' : 'bg-gray-200'
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
